import React from 'react';
import { CardLayout } from '../../layouts/CardLayout/CardLayout';
import ROUTES from 'routes.json';
import { ProductSupportLinks } from '../../components/ProductSupportLinks/ProductSupportLinks';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

const defaultMessage = 'Something went wrong.';

const ErrorPageComponent = ({ location }) => {
  const message = queryString.parse(location.search)['message'];
  return (
    <div data-test-page-name="Error">
      <CardLayout logoLink={ROUTES.PRODUCT}>
        <p className="lg">{message || defaultMessage}</p>
        <p>{message ? '' : 'Try to repeat the action.'}</p>
        <p>If you need help, contact our support team:</p>
        <ProductSupportLinks />
      </CardLayout>
    </div>
  );
};

export const ErrorPage = withRouter(ErrorPageComponent);
